module.exports = __webpack_public_path__ + "static/img/ranqiqiye.fbbefa7d.png";